// src/config/useCaseQuestionsConfig.js

const useCaseQuestionsConfig = {

  /* =========================
     QSR / FAST FOOD
  ========================== */

  "employee-productivity": [
    {
      key: "staffSize",
      question: "**Staff Size**\nHow many staff members work per shift?",
      widget: "staff-options",
    },
  ],

  "food-safety-hygiene": [
    {
      key: "kitchenStations",
      question: "**Kitchen Stations**\nHow many food preparation stations exist?",
    },
  ],

  "customer-wait-times": [
    {
      key: "billingCounters",
      question: "**Billing Counters**\nHow many order counters operate?",
    },
  ],

  "staff-ppe-compliance": [
    {
      key: "staffSize",
      question: "**Kitchen Staff**\nHow many staff members work in food preparation areas?",
      widget: "staff-options",
    },
  ],

  "inventory-wastage": [
    {
      key: "inventoryZones",
      question: "**Storage Zones**\nHow many storage or inventory areas exist?",
    },
  ],

  "shift-scheduling": [
    {
      key: "shiftCount",
      question: "**Shifts per Day**\nHow many operational shifts run daily?",
    },
  ],

  "cash-pos-reconciliation": [
    {
      key: "posCounters",
      question: "**POS Counters**\nHow many POS systems operate?",
    },
  ],

  /* =========================
     MANUFACTURING
  ========================== */

  "ppe-compliance": [
    {
      key: "staffSize",
      question: "**Worker Strength**\nHow many workers operate per shift?",
      widget: "staff-options",
    },
  ],

  "line-productivity": [
    {
      key: "assemblyLines",
      question: "**Production Lines**\nHow many assembly lines operate?",
    },
  ],

  "quality-defect": [
    {
      key: "inspectionPoints",
      question: "**Inspection Points**\nHow many quality inspection points exist?",
    },
  ],

  "unauthorised-zone": [
    {
      key: "restrictedZones",
      question: "**Restricted Zones**\nHow many restricted areas exist in the facility?",
    },
  ],

  "equipment-anomaly": [
    {
      key: "machines",
      question: "**Machine Count**\nHow many machines require monitoring?",
    },
  ],

  "ergonomics-fatigue": [
    {
      key: "staffSize",
      question: "**Operator Count**\nHow many operators work per shift?",
      widget: "staff-options",
    },
  ],

  "visitor-management": [
    {
      key: "visitorZones",
      question: "**Visitor Areas**\nHow many zones allow visitor or contractor access?",
    },
  ],

  /* =========================
     HEALTHCARE
  ========================== */

  "hand-hygiene": [
    {
      key: "washStations",
      question: "**Wash Stations**\nHow many hand sanitization stations exist?",
    },
  ],

  "patient-fall": [
    {
      key: "patientRooms",
      question: "**Patient Rooms**\nHow many rooms require fall monitoring?",
    },
  ],

  "ppe-gowning": [
    {
      key: "staffSize",
      question: "**Medical Staff**\nHow many healthcare workers operate per shift?",
      widget: "staff-options",
    },
  ],

  "restricted-area": [
    {
      key: "restrictedZones",
      question: "**Restricted Areas**\nHow many restricted hospital areas exist (ICU, OT etc)?",
    },
  ],

  "waiting-room": [
    {
      key: "waitingAreas",
      question: "**Waiting Areas**\nHow many waiting rooms are monitored?",
    },
  ],

  "asset-tracking": [
    {
      key: "medicalAssets",
      question: "**Mobile Equipment**\nHow many mobile medical assets need tracking?",
    },
  ],

  "duress-detection": [
    {
      key: "securityZones",
      question: "**Security Zones**\nHow many areas require aggression monitoring?",
    },
  ],

  /* =========================
     RETAIL
  ========================== */

  "footfall-heatmap": [
    {
      key: "outlets",
      question: "**Store Locations**\nHow many stores are monitored?",
    },
  ],

  "queue-management": [
    {
      key: "billingCounters",
      question: "**Checkout Counters**\nHow many billing counters operate per store?",
    },
  ],

  "theft-prevention": [
    {
      key: "sensitiveZones",
      question: "**High Value Zones**\nHow many product areas require theft monitoring?",
    },
  ],

  "planogram": [
    {
      key: "shelves",
      question: "**Shelf Count**\nHow many shelves require planogram monitoring?",
    },
  ],

  "staff-deployment": [
    {
      key: "staffSize",
      question: "**Store Staff**\nHow many staff members operate per store?",
      widget: "staff-options",
    },
  ],

  /* =========================
     CONSTRUCTION
  ========================== */

  "exclusion-zone": [
    {
      key: "restrictedZones",
      question: "**Hazard Zones**\nHow many hazardous or restricted zones exist?",
    },
  ],

  "plant-safety": [
    {
      key: "machines",
      question: "**Heavy Equipment**\nHow many machines operate on site?",
    },
  ],

  "progress-monitoring": [
    {
      key: "projectZones",
      question: "**Project Zones**\nHow many construction zones are tracked?",
    },
  ],

  "perimeter-security": [
    {
      key: "entryPoints",
      question: "**Site Entry Points**\nHow many entry gates exist?",
    },
  ],

  /* =========================
     HOSPITALITY
  ========================== */

  "guest-flow": [
    {
      key: "hotelAreas",
      question: "**Guest Areas**\nHow many areas (lobby, restaurant, lifts) are monitored?",
    },
  ],

  "pool-safety": [
    {
      key: "pools",
      question: "**Swimming Pools**\nHow many pools exist in the property?",
    },
  ],

  "staff-grooming": [
    {
      key: "staffSize",
      question: "**Hotel Staff**\nHow many staff members operate per shift?",
      widget: "staff-options",
    },
  ],

  "housekeeping": [
    {
      key: "rooms",
      question: "**Room Count**\nHow many rooms require housekeeping monitoring?",
    },
  ],

  "security": [
    {
      key: "securityZones",
      question: "**Security Zones**\nHow many areas require intruder monitoring?",
    },
  ],

};

export default useCaseQuestionsConfig;